//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
let d=[[[0,"EmissionIntensity",1,0],[0,"EmissionIntensityMode",1,0],[0,"EmissionProjectionDirection",1,"Direction",0],[0,"EmissionRotationAngle",1,0],[0,"EmissionUnits",1,0],[0,"EmitLight",1,0],[0,"MaterialName",1,0],[0,"NativeFileBrowserEmissionPartFile",1,0],[0,"ProjectionDirectionType",1,0],[0,"UseEmissionProfile",1,0],[0,"UseIntensityFromFile",1,0]],[[["nRGBColorPickerColor"],"GetEmissionColor",{R_:{rGBColorPickerColor:""}},0,0],[["rGBColorPickerColor"],"SetEmissionColor",{},1,0],[["filename"],"SetEmissionColorTexture",{},1,0],[[],"GetEmissionColorTexture",{R_:{filename:''}},0,0]],[]];
SPLM.Display.VisualMaterialEditorEmissionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.VisualMaterialEditorEmissionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.VisualMaterialEditorEmissionBuilder.EmissionUnitType = Object.freeze({
    "Lux" : "Lux", "Lumen" : "Lumen"});

SPLM.Display.VisualMaterialEditorEmissionBuilder.EmissionIntensityType = Object.freeze({
    "ConstantIntensity" : "ConstantIntensity", "ColorScalesIntensity" : "ColorScalesIntensity"});

SPLM.Display.VisualMaterialEditorEmissionBuilder.EmissionProjectionDirectionType = Object.freeze({
    "AlignWithFloorPlane" : "AlignWithFloorPlane", "UserDefined" : "UserDefined"});

export default SPLM;